import { useDispatch, useSelector } from "react-redux";
import { setIsInputChecked, setQuizType } from "../../redux/globalFunctions";
import { useEffect } from "react";
import translations from "../../en.json";
import translationsNo from "../../no.json";

export function QuizType() {
  const dispatch = useDispatch();
  const { quizType, language } = useSelector((state) => state.global);

  const handleRadioClick = (type) => {
    dispatch(setIsInputChecked(true));
    dispatch(setQuizType(type));
  };

  useEffect(() => {
    if (quizType !== null) {
      dispatch(setIsInputChecked(true));
    }
  }, [quizType]);

  const pageText =
    language === "en" ? translations.quizType : translationsNo.quizType;

  return (
    <div className="question">
      <p>{pageText.question}</p>
      <div className="radio-group">
        <div className="options">
          <input
            type="radio"
            name="prestart"
            value="short"
            id="short"
            checked={quizType === "short"}
            onChange={() => handleRadioClick("short")}
          />
          <label className="radio-label" htmlFor="short">
            {pageText.options.short}
          </label>
        </div>
        <div className="options">
          <input
            type="radio"
            name="prestart"
            value="long"
            id="long"
            checked={quizType === "long"}
            onChange={() => handleRadioClick("long")}
          />
          <label className="radio-label" htmlFor="long">
            {pageText.options.long}
          </label>
        </div>
      </div>
    </div>
  );
}
